import { WebRTCPlayer } from '@liveauctioneers/hammer-ui-core/webRTCPlayer';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useAppSelector } from '@/redux/hooks';
import { getAntMediaHostname } from '@/redux/modules/config';
import { getStreamStatus, hasVideoStream } from '@/redux/modules/video';

import { MessageScrollerContainer } from '../MessageScrollerContainer/MessageScrollerContainer';

type Props = {
    catalogId: number;
};

export const BiddingConsoleRightSection = ({ catalogId }: Props) => {
    const { streamId } = useAppSelector((state) => getStreamStatus(state, catalogId));
    const catalogHasVideoStream = useAppSelector((state) => hasVideoStream(state, catalogId));
    const antMediaHostname = useAppSelector(getAntMediaHostname);

    return (
        <div
            className={cn('grid h-full grid-rows-1 flex-col gap-md', {
                'grid-rows-[max-content_1fr]': catalogHasVideoStream,
            })}
        >
            {catalogHasVideoStream && (
                <WebRTCPlayer
                    className="aspect-auto min-h-[226px] rounded-sm"
                    debug={false}
                    hostname={antMediaHostname}
                    streamId={streamId}
                />
            )}
            <div className="h-full rounded-sm bg-background-primary">
                <MessageScrollerContainer catalogId={catalogId} />
            </div>
        </div>
    );
};
